export const logStatus = (logger, glue, { api, method, type, data }) => {
    if (type === "start") {
        glue?.metrics.featureMetric("finsemble-polyfill", api, method);
    }
    if (type === "deprecated") {
        glue?.metrics.featureMetric("finsemble-polyfill-deprecated", api, method);
        logger.error("DEPRECATED FUNCTION CALLED", `${api}.${method}()`, type, data);
        return;
    }
    if (logger[type]) {
        logger[type](`${api}.${method}()`, data);
        return;
    }
    logger.verbose(`${api}.${method}()`, type, data);
};
